import { useFragment } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import { Card, CardActionArea, CardActions, CardContent, CardMedia, Button, Typography } from "@mui/material";

function ProjectCardSmall({ projectRef }) {
    const project = useFragment(
        graphql`
            fragment ProjectCardSmall_project on Project {
                title
                description
                slug
                image
            }
        `,
        projectRef
    );

    const slugUrl = `#/projects/${project.slug}`;

    return (
        <Card data-testid="project-card">
            <CardActionArea>
                {project.image && <CardMedia image={project.image} title={project.title} sx={{ height: 140 }} />}
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        {project.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" component="p">
                        {project.description}
                    </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="small" color="primary" href={slugUrl}>
                    See Details
                </Button>
            </CardActions>
        </Card>
    );
}

export default ProjectCardSmall;
